
import BlockMedia from 'components/BlockMedia';
import ComponentPlaceholder from 'components/ComponentPlaceholder';
import type { DigizuiteAsset } from 'models/asset';
import type { ProductCard as ProductCardType } from 'models/productCard';
import type { Field, SitecoreBlockProps } from 'models/sitecore';
import { getEditorMargin } from 'utils/business-logic';
import { getAsset } from 'utils/helpers';

interface Props extends SitecoreBlockProps {
	fields?: {
		datasourceName?: string;
		products?: ProductCardType[];
		squareImage?: Field<DigizuiteAsset[]>;
	};
}

export default function MediaSquare({ fields, params }: Props) {
	if (!fields) {
		return null;
	}

	const { datasourceName, products, squareImage } = fields;
	const squareImg = getAsset('Templated 1:1', squareImage);

	if (!squareImg) {
		return (
			<ComponentPlaceholder
				componentName="ShortcutImages"
				description="Requires an image"
				className={getEditorMargin(params)}
			/>
		);
	}

	return (
		<div id={params?.anchor} className={getEditorMargin(params)}>
			<BlockMedia
				image={{
					src: squareImg?.src,
					alt: squareImg?.alt,
					variant: 'square',
				}}
				products={products}
				productsDisplayType="shopByMedia"
				gtmItemListId="block"
				gtmItemListName={`Block: ${datasourceName ?? 'MediaSquareUnknown'}`}
			/>
		</div>
	);
}
MediaSquare.displayName = 'MediaSquare';
